module.exports = __webpack_public_path__ + "static/media/ar2.b0d385e4.jpg";